import Axios from 'axios'
import axios from '../../axios'
import { useRef, useState, useEffect } from 'react'

export function usePagination(path, extra) {
  const { method = "POST" } = extra || {}
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState([])
  const ref = useRef({
    page: 0,
    rowsPerPage: 25,
    sortModel: undefined,
    sort: undefined,
    filters: [],
    cancelTokenSource: () => {},
  })
  const [totalPages, setTotalPages] = useState(0)
  const [totalElements, setTotalElements] = useState(0)

  const setRowsPerPage = (rowsPerPage) => {
    ref.current.rowsPerPage = rowsPerPage
    setPage(0)
  }

  const setSortModel = (sortModel) => {
    ref.current.sortModel = sortModel
    ref.current.sort = sortModel?.length
      ? { column: sortModel[0].field, direction: sortModel[0].sort }
      : undefined
    setPage(0)
    // alert("here")
  }
  const setFilterModel = (filterModel) => {
    ref.current.filters = filterModel.items.filter(
      ({ value }) => value !== undefined && value !== ''
    )
    setPage(0)
  }

  const setPage = (page) => {
    ref.current.page = page
    getData()
  }

  const getData = () => {
    if (typeof ref.current.cancelTokenSource == 'function')
      ref.current.cancelTokenSource()
    const cancelTokenSource = Axios.CancelToken.source()
    ref.current.cancelTokenSource = cancelTokenSource.cancel
    setLoading(true)
    const { rowsPerPage, page, sort, filters } = ref.current
    const isPost = method === "POST"
    const req = isPost ? axios.post : axios.get 
    const params = { filters, sort }
    req(
        `${path}?size=${rowsPerPage}&page=${page}`,
        isPost ? params : { params },
        {
          cancelTokenSource,
        }
      )
      .then(({ data }) => {
        if (data?.content) {
          setTotalPages(data.totalPages)
          setTotalElements(data.totalElements)
          setList(data.number === 0 ? data.content : list.concat(data.content))
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    list,
    page: ref.current.page,
    rowsPerPage: ref.current.rowsPerPage,
    sort: ref.current.sort,
    sortModel: ref.current.sortModel,
    filters: ref.current.filters,
    getData,
    setRowsPerPage,
    setPage,
    loading,
    totalPages,
    totalElements,
    setSortModel,
    setFilterModel,
  }
}
